<template>
    <!--工业燃气报警器-->
   <div>
        <TableBlock ref="tableData" :columns="columns" :action="action" :showBtn="true" :ispage="true" :autRequest="false"  :param="param" :navHeight="270"  @checkVal="getCheckVal">
           <div class="common-space-between">
               <div class="common-space-around">
                   <InputBlock title="预警名称">
                      <el-input v-model="param.policeName" :size="this.$store.state.inputSize" placeholder="请输入预警名称" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
                   </InputBlock>
                   <SelectBlock keyVal="alarmType" ref="alarmType"  title="报警类型" :size="this.$store.state.inputSize" placeholder="请选择报警类型" :options="alarmType"  left="10" right="10"  width="150" @getVal="getAlarmType" />
                   <el-button type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"  @click="searchBtn">搜索</el-button>
                   <el-button type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn">重置</el-button>
               </div>
               <el-button type="primary" icon="el-icon-plus" size="small" @click="addBtn">新增</el-button>
           </div>
        </TableBlock>
        <!--新增编辑-->
        <AddEidtBlock ref="child" />
   </div>
 </template>
 <script>
 import TableBlock from '@/components/component-Table/block-table.vue'
 import TReeBlock from '@/components/component-block/block-newTree.vue'
 import AddEidtBlock from './addEidt.vue'
 import {columns} from './columns';
 import {operate} from '@/utils/config'
 import { putFun,getFun,postFun } from '@/utils/httpFun';
 export default {
   name: 'index',
   components:{
       TableBlock:TableBlock,
       TReeBlock:TReeBlock,
       AddEidtBlock:AddEidtBlock
   },
   data:()=>({  
      listType:[],
      alarmType:[],
      action:operate.BAOJINGSETLIST,
      columns:[],    //表头
      param:{        //请求参数
         policeName:null,
         policeType:null,
         policeScope:1,
         dtId:""
      }     
   }),
   created(){
      this.columns = columns(this);
      
    
   },
   mounted(){
     let eqData =  JSON.parse(localStorage.getItem("EQTYPEVALE"))
     this.param.dtId = eqData.id    
     this.$nextTick(res=>{
        this.$refs.tableData.getDatas()
        postFun(operate.BAOJINGTYPELIST,{dtId:this.param.dtId},res=>{
            let list = res.data
               for(var i in list){
                  list[i].indexNo = list[i].id
                  list[i].selectName = list[i].policeTypeName
               }
            this.alarmType = list
         })
     })
   },
   methods:{
     
      getAlarmType(ev){
          this.param.policeType = ev.id
      },

     //新增 
     addBtn(){
        let datas = {
            mark:"add",
            dtId:this.param.dtId,
            listData:{}
        } 
        this.$refs.child.openBtn(datas)
     },

      //编辑套餐
      eidtBtn(ev){
         getFun(operate.BAOJINGDETAILS,{policeConfigId:ev.id},res=>{
             let parms = res.data
                 parms.policeConfigDetails = JSON.parse(parms.policeConfigDetails) 
             let datas = {
                 mark:"eidt",
                 dtId:this.param.dtId,
                 listData:parms
             }
             this.$refs.child.openBtn(datas) 
         })
     },

     //重置从第一页开始
     resetBtn(){
        this.param.policeName = null
        this.param.policeType = null
        this.$refs.alarmType.setVal(null)
        this.$nextTick(res=>{
            this.$refs.tableData.resetHttp() 
        })
     },

     //搜索
     searchBtn(ev){
       this.$nextTick(res=>{
           this.$refs.tableData.resetHttp() 
       })
     },

     //获取设备分类ID
     getDtId(ev){
         this.param.dtId = ev.val.id
     },

     //删除套餐
     deleteBtn(ev){
        console.log("删除",ev)
        this.$confirm('确认要删除'+ev.policeName+"?", '温馨提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            customClass:"popDeleteW",
         }).then(() => {
             putFun(operate.BAOJINGDELETE+"?policeConfigId="+ev.id,{},res=>{
                 if(res.data){
                    this.$refs.tableData.getDatas() 
                 }
             })
         }).catch(() => {

         }); 
     },

     //复选框的值   
     getCheckVal(val){
       console.log(val)
     }
   }
 }
 </script>
 <style lang="scss" scoped>
      .titleText{
         font-size: 14px;
         color: #606266;
         margin-right: 10px;
      }
      .warp-tree{
         margin-right: 10px;
      }
      ::v-deep .el-button--mini{
        padding: 5px 8px;
      }
     
 </style>
 